<template>
  <v-col v-for="item in sport_store" :key="item.sport_id">
    <v-card class="mx-auto"  max-width="90%">
      <v-card-text>
        <v-row class="justify-space-between">
          <v-col>
            <p class="text-h4 text--primary">
              {{ item.store_name }}
            </p>
            <div class="text--primary">
              {{ item.appeal_point}}
            </div>
          </v-col>
          <v-col v-if="!addEdit"  class="text-right">
            <v-btn icon color="primary" :to="{ name: 'update-sportsstoreedit', params: {sportsStoreId: item.sports_store_id} }"><v-icon>mdi-pencil</v-icon></v-btn>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-chip class="ma-2" v-for="chip in item.sports_store_sports_gear" :key="chip.recode_id">
            {{  chip.sport_id }}
          </v-chip>
        </div>
        <v-carousel v-if="item.sports_store_photo.length" cycle height="400" hide-delimiter-background show-arrows-on-hover>
          <v-carousel-item v-for="slide in item.sports_store_photo" :key="slide.record_id">
            <v-sheet height="100%" >
              <v-row class="fill-height" align="center" justify="center">
                <v-img :src="slide.path"></v-img>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-card-text>
      <v-card-actions>
        <v-btn
          variant="text"
          color="teal-accent-4"
          @click="item.reveal = true"
        >
          Learn More
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <v-card
          v-if="item.reveal"
          class="v-card--reveal"
          style="height: 100%;"
        >
          <v-card-text class="pb-0">
            <p class="text-h4 text--primary">
              Origin
            </p>
            <MessageChat/>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn
              variant="text"
              color="teal-accent-4"
              @click="item.reveal = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-expand-transition>
    </v-card>
  </v-col>
</template>
  
<script>
  import MessageChat from '@/components/MessageChat.vue'
  import axios from 'axios'

  export default {
    components: {
        MessageChat,
    },
    data: () => ({
      reveal: false,
      sport_store: [
        {
              "access": "JR渋谷駅より徒歩5分",
              "address_building_name": "スポーツビル101",
              "address_city_town_village": "渋谷区",
              "address_postal_code": "123-4567",
              "address_prefecture": "東京都",
              "address_street_number": "2001-2-3",
              "appeal_point": "スポーツ用品全般を取り扱っています。",
              "business_hours": "10:00〜20:00",
              "created_date": "Thu, 01 Jun 2023 00:00:01 GMT",
              "created_user_id": "1001",
              "last_updated_date": "Thu, 15 Jun 2023 00:00:00 GMT",
              "map_url": "https://maps.example.com/sportsworld",
              "parking_lot_availability": true,
              "phone_number": "012-345-6789",
              "regular_holiday": "月曜日",
              "sports_store_id": 1001,
              "sports_store_inquiry": [
                  {
                      "answer": "在庫は十分にございます。ご来店お待ちしております。",
                      "created_date": "Wed, 12 Jul 2023 15:04:30 GMT",
                      "created_user_id": "1001",
                      "inquiry_content": "商品の在庫状況について教えてください。",
                      "last_updated_date": "Wed, 12 Jul 2023 15:04:30 GMT",
                      "record_id": 1,
                      "sports_store_id": 1,
                      "updated_user_id": "1001"
                  },
                  {
                      "answer": "",
                      "created_date": "Wed, 12 Jul 2023 15:04:30 GMT",
                      "created_user_id": "1002",
                      "inquiry_content": "トレーニングシューズの価格はいくらですか？",
                      "last_updated_date": "Wed, 12 Jul 2023 15:04:30 GMT",
                      "record_id": 2,
                      "sports_store_id": 1,
                      "updated_user_id": ""
                  },
                  {
                      "answer": "配送オプションはありません。店舗での受け取りになります。",
                      "created_date": "Wed, 12 Jul 2023 15:04:30 GMT",
                      "created_user_id": "1003",
                      "inquiry_content": "配送オプションについて教えてください。",
                      "last_updated_date": "Wed, 12 Jul 2023 15:04:30 GMT",
                      "record_id": 3,
                      "sports_store_id": 1,
                      "updated_user_id": "1003"
                  }
              ],
              "sports_store_link": [
                  {
                      "category": "URL",
                      "created_date": "Wed, 12 Jul 2023 15:12:32 GMT",
                      "created_user_id": "SYSTEM",
                      "last_updated_date": "Wed, 12 Jul 2023 15:12:38 GMT",
                      "path": "https://maps.example.com/sportsworld",
                      "record_id": 1,
                      "sports_store_id": 1,
                      "updated_user_id": "SYSTEM"
                  }
              ],
              "sports_store_photo": [
                  {
                      "created_date": "Wed, 12 Jul 2023 15:13:53 GMT",
                      "created_user_id": "SYSTEM",
                      "last_updated_date": "Wed, 12 Jul 2023 15:13:59 GMT",
                      "path": "/store/1/1.jpg",
                      "record_id": 1,
                      "sports_store_id": 1,
                      "updated_user_id": "SYSTEM"
                  },
                  {
                      "created_date": "Wed, 12 Jul 2023 15:13:53 GMT",
                      "created_user_id": "SYSTEM",
                      "last_updated_date": "Wed, 12 Jul 2023 15:13:59 GMT",
                      "path": "/store/1/glove17.jpg",
                      "record_id": 2,
                      "sports_store_id": 1,
                      "updated_user_id": "SYSTEM"
                  }
              ],
              "sports_store_sports_gear": [
                  {
                      "created_date": "Wed, 12 Jul 2023 15:04:30 GMT",
                      "created_user_id": "SYSTEM",
                      "last_updated_date": "Wed, 12 Jul 2023 15:04:35 GMT",
                      "recode_id": 1,
                      "sport_id": "baseball",
                      "sports_store_id": 1,
                      "updated_user_id": "SYSTEM"
                  },
                  {
                      "created_date": "Wed, 12 Jul 2023 15:04:30 GMT",
                      "created_user_id": "SYSTEM",
                      "last_updated_date": "Wed, 12 Jul 2023 15:04:35 GMT",
                      "recode_id": 2,
                      "sport_id": "soccer",
                      "sports_store_id": 1,
                      "updated_user_id": "SYSTEM"
                  }
              ],
              "store_name": "Sports World",
              "updated_user_id": "1001"
          },
          {
            "access": "地下鉄中央駅より徒歩3分",
            "address_building_name": "スポーツセンター302",
            "address_city_town_village": "中央区",
            "address_postal_code": "987-6543",
            "address_prefecture": "大阪府",
            "address_street_number": "2004-5-6",
            "appeal_point": "最新のスポーツ用具を取り揃えています。",
            "business_hours": "9:00〜18:00",
            "created_date": "Fri, 02 Jun 2023 00:00:00 GMT",
            "created_user_id": "1002",
            "last_updated_date": "Wed, 14 Jun 2023 00:00:00 GMT",
            "map_url": "https://maps.example.com/sportszone",
            "parking_lot_availability": true,
            "phone_number": "987-654-3210",
            "regular_holiday": "水曜日",
            "sports_store_id": 2,
            "sports_store_inquiry": [
            ],
            "sports_store_link": [
            ],
            "sports_store_photo": [
            ],
            "sports_store_sports_gear": [
            ],
            "store_name": "Sports Zone",
            "updated_user_id": "1002"
          },
        ]
    }),
    created: function () {
      this.getData()
    },
    methods: {
      getData() {
        axios.get(process.env.VUE_APP_API_URL + '/sportsstore/list')
          .then(response => {
            console.log(response.data); // mockData
            console.log(response.status); // 200
            this.sport_store = response.data.sport_store
        })
      },
    },
  }
</script>